import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import { postRequest } from "../../utils/axiosrequest";
import { Country } from "../../utils/Country";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header3 from "../../components/Header/Header3";
import "../Login/login.scss";
import { useAuth } from "../../ProtectedRoute/AuthContext";

const Support = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userMobile = location?.state?.phone_no;
  const { handleLogin } = useAuth();
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    document.title = "Sign Up | Ballers";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [Code, setCode] = useState("+91");
  const [hidden, sethidden] = useState(true);
  const [cityHidden, setCityHidden] = useState(true);
  const [countryHidden, setCountryHidden] = useState(true);
  const [User, setUser] = useState({
    member_name: "",
    country_code: Code,
    phone_no: userMobile || "",
    email_id: "",
    DOB: "",
    city: "",
    country: "",
    referral_code: "",
  });
  const [isTrimmed, setIsTrimmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cities = [
    "Bangalore",
    "Chennai",
    "Delhi",
    "Gurgaon",
    "Hyderabad",
    "Mumbai",
    "Noida",
    "Pune",
  ];

  const countries = ["India"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const selectedCountry = Country.find(
      (country) => country.dial_code === User.country_code
    );

    if (name === "phone_no") {
      const maxLength = selectedCountry.phone_length;

      if (value.length >= maxLength) {
        const trimmedValue = value.slice(0, maxLength);
        setUser({ ...User, [name]: trimmedValue });
        setIsTrimmed(true);
      } else {
        setUser({ ...User, [name]: value });
        setIsTrimmed(false);
      }
    } else {
      setUser({ ...User, [name]: value });
    }
  };

  const handleformSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const endpoint =
        "https://ballersapi.ballerslife.co/api/v1/memberships/contact-us";
      const payload = {
        name: User.member_name || "",
        email: User.email_id,
        message: User.help,
      };
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const responseData = await response.json();
      if (response.ok) {
        toast.success(responseData.message);
        setUser({
          member_name: "",
          email_id: "",
          help: "",
        });
      } else {
        toast.error("Failed to send your message. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetOTP = async () => {
    if (!User.phone_no) {
      toast.error("Please enter a phone number first.");
      return;
    }

    try {
      setOTP(["", "", "", "", "", ""]);
      const selectedCountry = Country.find(
        (country) => country.dial_code === User.country_code
      );
      const maxLength = selectedCountry?.phone_length || 10;

      if (User.phone_no.length < maxLength) {
        toast.error(
          `Phone number must be at least ${maxLength} digits to verify.`
        );
        return;
      }
      const otpEndpoint = `memberships/signup_send_otp?country_code=${
        User.country_code
      }&phone_no=${encodeURIComponent(User.phone_no)}`;
      const { data } = await postRequest(otpEndpoint, {}, token);

      if (data?.message === "OTP sent to your registered number") {
        toast.success(data?.message);
        setResendTimer(180);
        setStartTimer(true);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const handleVerifyOtp = async (e) => {
    try {
      const verifyOtpEndpoint = `memberships/signup_verify_otp?country_code=${encodeURIComponent(
        User.country_code
      )}&phone_no=${encodeURIComponent(User.phone_no)}&otp=${encodeURIComponent(
        User.otp
      )}`;

      const otpResponse = await postRequest(verifyOtpEndpoint, {}, token);
      if (otpResponse?.data?.message === "OTP verified successfully") {
        toast.success(otpResponse.data.message);
        setOtpVerified(true);
      } else if (
        otpResponse?.data?.message === "Phone number already verified"
      ) {
        toast.success(otpResponse.data.message);
        setOtpVerified(true);
      } else {
        toast.error(otpResponse.message);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const [resendTimer, setResendTimer] = useState(180);
  const [startTimer, setStartTimer] = useState(false);
  const minutes = Math.floor(resendTimer / 60);
  const seconds = resendTimer % 60;
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [verifyClicked, setVerifyClicked] = useState(false);
  const [showOTPFilled, setShowOTPFilled] = useState(false);
  const [otpVerifyBtn, setOTPVerifyBtn] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const inputRefs = useRef([]);

  const handleOTPChange = (index, value) => {
    if (index > 4) {
      setOTPVerifyBtn(true);
      setVerifyClicked(false);
    }
    if (!isNaN(value) && value !== "") {
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "Backspace" && otp[index] !== "") {
      const newOTP = [...otp];
      newOTP[index] = "";
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
    }
  };

  const handleSendOTP = async () => {
    if (verifyClicked) return;

    if (!User.phone_no) {
      toast.error("Please enter a phone number first.");
      return;
    }

    try {
      const selectedCountry = Country.find(
        (country) => country.dial_code === User.country_code
      );
      const maxLength = selectedCountry?.phone_length || 10;

      if (User.phone_no.length < maxLength) {
        toast.error(
          `Phone number must be at least ${maxLength} digits to verify.`
        );
        return;
      }

      const token = localStorage.getItem("access_token");
      const otpEndpoint = `memberships/signup_send_otp?country_code=${encodeURIComponent(
        User.country_code
      )}&phone_no=${encodeURIComponent(User.phone_no)}`;

      setVerifyClicked(true);
      const res = await postRequest(otpEndpoint, {}, token);
      if (res?.data === "Phone number already verified.") {
        toast.success(res.data);
        setOtpVerified(true);
        setOTPVerifyBtn(true);
      } else if (res?.data?.message === "OTP sent to your registered number") {
        toast.success(res?.data?.message);
        setShowOTPFilled(true);
        setResendTimer(180);
        setStartTimer(true);
      } else {
        toast.error(res?.response?.data?.detail);
        setVerifyClicked(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setVerifyClicked(false);
    }
  };

  useEffect(() => {
    let timer;
    if (startTimer && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [startTimer, resendTimer]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get("referralCode");

    if (referralCode) {
      setUser((prevUser) => ({
        ...prevUser,
        referral_code: referralCode,
      }));
    }
  }, [location.search]);

  return (
    <div className="request_section">
      <div className="request_content">
        <Header3 />
        <div className="form">
          <div className="title_signUp">
            <h2>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              Contact Us <br />
              <p className="breakLineSignUp"> </p>
            </h2>
            <div className="info">
              {/* <div className="rectangle"></div> */}
              <p>
                <p className="title2">
                  Need help? Don’t sweat it! We are here to help you out.
                </p>
                <p className="title2">
                  You can write to us at contact@ballerslife.co
                </p>
                <div className="abs2">
                  <img src={abs2} alt="" />
                </div>
              </p>
            </div>
          </div>
          <div className="form_wrapper">
            <form onSubmit={handleformSubmit}>
              {/* <p className="loginTxt">Support</p> */}
              <p className="tagLine">How can we help you?</p>

              <label htmlFor="member_name" className="input-group">
                Name
              </label>
              <input
                type="text"
                id="member_name"
                name="member_name"
                placeholder="Please enter your name"
                value={User.member_name}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="email_id" className="input-group email">
                Email
              </label>
              <input
                type="email"
                id="email_id"
                name="email_id"
                placeholder="Please enter your Email ID"
                value={User.email_id}
                onChange={handleInputChange}
                required
              />
              <label htmlFor="help" className="input-group email">
                What can we help you with?
              </label>
              <textarea
                id="help"
                name="help"
                placeholder="Describe your issue or question"
                value={User.help || ""}
                onChange={handleInputChange}
                required
                rows={3}
                style={{
                  resize: "vertical",
                  backgroundColor: "#210d40",
                  color: "#fff",
                  border: "none",
                  padding: "7px",
                }}
              />

              <button type="submit" disabled={isLoading}>
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
